import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-xl border border-slate-200 shadow-sm p-4 sm:p-5 mb-6 min-w-0" }
const _hoisted_2 = { class: "flex flex-wrap gap-4 items-end min-w-0" }
const _hoisted_3 = { class: "min-w-0 flex-1 sm:flex-none sm:min-w-[10rem]" }
const _hoisted_4 = { class: "min-w-0 flex-1 sm:flex-none sm:min-w-[10rem]" }
const _hoisted_5 = {
  key: 0,
  class: "mb-6 min-w-0"
}
const _hoisted_6 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mb-6 min-w-0" }
const _hoisted_7 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mb-6 min-w-0" }
const _hoisted_8 = { class: "min-w-0" }

import { ref, computed } from "vue";

import { useDashboardQuery } from "../composables/useDashboardQuery";
import { useInventarioQuery } from "../composables/useInventarioQuery";
import { useProductosMasVendidosQuery } from "../composables/useProductosMasVendidosQuery";
import { useTopClientesQuery } from "../composables/useTopClientesQuery";
import { useVentasCategoriaQuery } from "../composables/useVentasCategoriaQuery";
import { useVentasMetodoPagoQuery } from "../composables/useVentasMetodoPagoQuery";
import { useVentasPeriodoQuery } from "../composables/useVentasPeriodoQuery";
import DashboardStatsCards from "../components/DashboardStatsCards.vue";
import VentasPeriodoChart from "../components/VentasPeriodoChart.vue";
import ProductosMasVendidosChart from "../components/ProductosMasVendidosChart.vue";
import TopClientesChart from "../components/TopClientesChart.vue";
import VentasCategoriaChart from "../components/VentasCategoriaChart.vue";
import VentasMetodoPagoChart from "../components/VentasMetodoPagoChart.vue";
import InventarioChart from "../components/inventarioChart.vue";
import AdminPageShell from "@/share/components/admin/AdminPageShell.vue";

// WebSocket para actualizaciones en tiempo real

// Queries

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const { dashboardData, isLoading } = useDashboardQuery();
const { productosVendidosData, isLoading: isLoadingProductosVendidos } =
  useProductosMasVendidosQuery(10);
const { topClientesData, isLoading: isLoadingTopClientes } =
  useTopClientesQuery(10);
const { inventarioData, isLoading: isLoadingInventario } = useInventarioQuery();
// Fechas para filtros
const fechaInicio = ref("");
const fechaFin = ref("");
const ventasEnabled = ref(false);

const fechaInicioRef = computed(() => fechaInicio.value);
const fechaFinRef = computed(() => fechaFin.value);
const ventasEnabledRef = computed(() => ventasEnabled.value);

const ventasPeriodoQuery = useVentasPeriodoQuery(
  fechaInicioRef,
  fechaFinRef,
  ventasEnabledRef
);

const { ventasCategoriaData, isLoading: isLoadingVentasCategoria } =
  useVentasCategoriaQuery(fechaInicioRef, fechaFinRef);
const { ventasMetodoPagoData, isLoading: isLoadingVentasMetodoPago } =
  useVentasMetodoPagoQuery(fechaInicioRef, fechaFinRef);

const ventasPeriodoData = computed(() => ventasPeriodoQuery.data.value);

// Función para buscar ventas
const buscarVentas = () => {
  if (fechaInicio.value && fechaFin.value) {
    ventasEnabled.value = true;
  }
};

// Inicializar fechas (últimos 7 días)
const hoy = new Date();
const hace7Dias = new Date();
hace7Dias.setDate(hoy.getDate() - 7);

fechaInicio.value = hace7Dias.toISOString().split("T")[0];
fechaFin.value = hoy.toISOString().split("T")[0];
ventasEnabled.value = true;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminPageShell, {
    title: "Dashboard de ventas",
    description: "Resumen general del negocio.",
    "compact-description": false
  }, {
    default: _withCtx(() => [
      _createVNode(DashboardStatsCards, {
        data: _unref(dashboardData),
        loading: _unref(isLoading)
      }, null, 8, ["data", "loading"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("label", { class: "block text-xs sm:text-sm font-semibold text-slate-700 mb-1.5" }, "Fecha inicio", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fechaInicio).value = $event)),
              type: "date",
              class: "w-full min-w-0 border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:ring-2 focus:ring-red-500/25 focus:border-red-500"
            }, null, 512), [
              [_vModelText, fechaInicio.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "block text-xs sm:text-sm font-semibold text-slate-700 mb-1.5" }, "Fecha fin", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fechaFin).value = $event)),
              type: "date",
              class: "w-full min-w-0 border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:ring-2 focus:ring-red-500/25 focus:border-red-500"
            }, null, 512), [
              [_vModelText, fechaFin.value]
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: buscarVentas,
            class: "w-full sm:w-auto px-5 py-2.5 rounded-lg bg-gradient-to-r from-red-600 to-red-700 text-white text-sm font-semibold shadow-sm hover:shadow transition-shadow"
          }, " Buscar ")
        ])
      ]),
      (ventasEnabled.value && ventasPeriodoData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(VentasPeriodoChart, {
              data: ventasPeriodoData.value,
              loading: _unref(ventasPeriodoQuery).isLoading.value
            }, null, 8, ["data", "loading"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(ProductosMasVendidosChart, {
          data: _unref(productosVendidosData),
          loading: _unref(isLoadingProductosVendidos)
        }, null, 8, ["data", "loading"]),
        _createVNode(TopClientesChart, {
          data: _unref(topClientesData),
          loading: _unref(isLoadingTopClientes)
        }, null, 8, ["data", "loading"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(VentasCategoriaChart, {
          data: _unref(ventasCategoriaData),
          loading: _unref(isLoadingVentasCategoria)
        }, null, 8, ["data", "loading"]),
        _createVNode(VentasMetodoPagoChart, {
          data: _unref(ventasMetodoPagoData),
          loading: _unref(isLoadingVentasMetodoPago)
        }, null, 8, ["data", "loading"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(InventarioChart, {
          data: _unref(inventarioData),
          loading: _unref(isLoadingInventario)
        }, null, 8, ["data", "loading"])
      ])
    ]),
    _: 1
  }))
}
}

})